import React from 'react';
import axios from 'axios';
import Table from '../../components/Table';
import './style.css';

export default class Answers extends React.Component {
    constructor(props) {
        super(props);

        const columns = [
            {
                Header: 'Číslo odpovědi',
                accessor: 'name',
            }, {
                Header: 'Znění odpovědi',
                accessor: 'text',
            }
        ];

        const tableOptions = {
            showPagination: true,
            showPageSizeOptions: true,
            showPageJump: true,
            collapseOnSortingChange: true,
            collapseOnPageChange: true,
            collapseOnDataChange: true,
            freezeWhenExpanded: false,
            filterable: true,
            sortable: true,
            resizable: true,
            defaultPageSize: 5
        };

        this.state = {
            answers: [],
            columns: columns,
            tableOptions: tableOptions
        };
    }

    componentDidMount() {
        let loginToken = this.props.sessionData.accessToken;
        let config = {
            headers: {
                'Authorization': 'Bearer ' + loginToken
            }
        };
        axios.get(this.props.api.questionAnswers + this.props.id, config).then((result) => {
                let newLength = result.data.length;
                let showPagination = true;
                let pageSize = this.state.tableOptions.defaultPageSize;
                if (newLength < this.state.tableOptions.defaultPageSize) {
                    showPagination = false;
                    pageSize = newLength;
                }
                if (!this._calledComponentWillUnmount) {
                    this.setState({
                        answers: result.data,
                        tableOptions: {
                            ...this.state.tableOptions,
                            loading: false,
                            pageSize: pageSize,
                            showPagination: showPagination
                        }
                    });
                }
            }).catch(function (error) {
                console.error('Error axios:', error);
        });
    };

    render() {
        const getTrProps = (state, rowInfo, column) => {
            return {
                style: {
                    background: rowInfo ? (rowInfo.original.correctness ? 'rgba(0,255,0,0.2)' : 'rgba(216, 0, 0, 0.2)') : null
                }
            }
        };

        return (
            <Table
                columns={this.state.columns}
                data={this.state.answers}
                tableOptions={this.state.tableOptions}
                defaultFilterMethod={(filter, row) => (String(row[filter.id]).includes(filter.value))}
                options={{getTrProps}}
            />
        );
    }
}


/** WEBPACK FOOTER **
 ** ./src/containers/Questions/Answers.js
 **/